import { render, staticRenderFns } from "./PatFiles.vue?vue&type=template&id=fa4cbc3c&scoped=true"
import script from "./PatFiles.vue?vue&type=script&lang=js"
export * from "./PatFiles.vue?vue&type=script&lang=js"
import style0 from "./PatFiles.vue?vue&type=style&index=0&id=fa4cbc3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4cbc3c",
  null
  
)

export default component.exports